export default __webpack_public_path__ + "static/media/search-icon-gray.e037402a.svg";